<template>
    <v-dialog 
        v-model="not.notShow" 
        max-width="450"                     
        :persistent='not.notHd'  >
        <v-card>
            <v-card-title class="headline"
            primary-title
            >{{not.notH}}</v-card-title>  
            <v-card-text> 
                <div class="mb-3">
                    {{not.notTx}}
                </div>
                <form id="itemDetailForm" @submit.prevent="onNotYes()">
                    <v-flex xs12   > 
                        <v-text-field required  
                        filled="" type="password"
                        v-model="input.password" 
                        label="Password"> 
                        </v-text-field > 
                    </v-flex>  
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn v-if="not.notNoTx!==''" 
                            color="primary" text="" 
                        @click="onNotNo">{{not.notNoTx}}</v-btn>
                        <v-btn color="primary" 
                            :loading="input.loading" 
                            dark="" type="submit">{{not.notYesTx}}</v-btn>
                    </v-card-actions>
                </form> 
                
            </v-card-text>  
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props:['notShow','notHd','notH','notTx','notNoTx','notYesTx'], 
    data(){
        return{
            show:false,
            input:{}
        } 
    }, 
    mounted(){ 
    },
    computed:{
        not(){ 
            return  this.$store.getters.getNotDialogCp
        }
    },
    methods:{
        onNotNo(){
            this.EventBus.$emit('notNoDialog',this.not.notAction) 
            this.$store.dispatch('setNotDialogCp',{})
        },
        onNotYes(){
            this.input.loading = true
            setTimeout(() => {
                let notAction = {
                    ...this.not.notAction,
                    password:this.input.password
                } 
                this.EventBus.$emit('notYesDialog',notAction) 
                this.$store.dispatch('setNotDialogCp',{}) 
            }, 2000);
        },
        submited(){
            console.log(this.not);
            
        }
    },
    watch:{
        not(value){
            this.input = {}
           // console.log(value,"wwwwwwwwww");  
        },
         
    } 
}
</script>
